export interface BooqableEndpoint {
  path: string;
  description: string;
}

export interface BooqableEndpointCategory {
  category: string;
  endpoints: BooqableEndpoint[];
}

export const booqableEndpoints: BooqableEndpointCategory[] = [
  { category: 'Authentication Methods', endpoints: [
    { path: 'GET /api/4/authentication_methods', description: 'List authentication methods' },
    { path: 'GET /api/4/authentication_methods/{id}', description: 'Fetch authentication method' },
    { path: 'POST /api/4/authentication_methods', description: 'Create authentication method' },
    { path: 'DELETE /api/4/authentication_methods/{id}', description: 'Delete authentication method' },
  ]},
  { category: 'Barcodes', endpoints: [
    { path: 'GET /api/4/barcodes', description: 'List barcodes' },
    { path: 'GET /api/4/barcodes/{id}', description: 'Fetch barcode' },
    { path: 'POST /api/4/barcodes', description: 'Create barcode' },
    { path: 'PUT /api/4/barcodes/{id}', description: 'Update barcode' },
    { path: 'DELETE /api/4/barcodes/{id}', description: 'Delete barcode' },
  ]},
  { category: 'Bundles', endpoints: [
    { path: 'GET /api/4/bundles', description: 'List bundles' },
    { path: 'GET /api/4/bundles/{id}', description: 'Fetch bundle' },
    { path: 'POST /api/4/bundles', description: 'Create bundle' },
    { path: 'POST /api/4/bundles/search', description: 'Search bundles' },
    { path: 'PUT /api/4/bundles/{id}', description: 'Update bundle' },
  ]},
  { category: 'Bundle Items', endpoints: [
    { path: 'GET /api/4/bundle_items', description: 'List bundle items' },
    { path: 'GET /api/4/bundle_items/{id}', description: 'Fetch bundle item' },
    { path: 'POST /api/4/bundle_items', description: 'Create bundle item' },
    { path: 'PUT /api/4/bundle_items/{id}', description: 'Update bundle item' },
    { path: 'DELETE /api/4/bundle_items/{id}', description: 'Delete bundle item' },
  ]},
  { category: 'Clusters', endpoints: [
    { path: 'GET /api/4/clusters', description: 'List clusters' },
    { path: 'GET /api/4/clusters/{id}', description: 'Fetch cluster' },
    { path: 'POST /api/4/clusters', description: 'Create cluster' },
    { path: 'PUT /api/4/clusters/{id}', description: 'Update cluster' },
    { path: 'DELETE /api/4/clusters/{id}', description: 'Delete cluster' },
  ]},
  { category: 'Collections', endpoints: [
    { path: 'GET /api/4/collections', description: 'List collections' },
    { path: 'GET /api/4/collections/{id}', description: 'Fetch collection' },
    { path: 'POST /api/4/collections', description: 'Create collection' },
    { path: 'PUT /api/4/collections/{id}', description: 'Update collection' },
    { path: 'DELETE /api/4/collections/{id}', description: 'Delete collection' },
  ]},
  { category: 'Collection Items', endpoints: [
    { path: 'GET /api/4/collection_items', description: 'List collection items' },
    { path: 'POST /api/4/collection_items', description: 'Create collection item' },
    { path: 'DELETE /api/4/collection_items/{id}', description: 'Delete collection item' },
  ]},
  { category: 'Companies', endpoints: [
    { path: 'GET /api/4/companies/{id}', description: 'Fetch company' },
    { path: 'GET /api/4/companies/{id}/subscription_details', description: 'Fetch subscription' },
    { path: 'PUT /api/4/companies/{id}', description: 'Update company' },
  ]},
  { category: 'Countries', endpoints: [
    { path: 'GET /api/4/countries', description: 'List countries' },
  ]},
  { category: 'Coupons', endpoints: [
    { path: 'GET /api/4/coupons', description: 'List coupons' },
    { path: 'GET /api/4/coupons/{id}', description: 'Fetch coupon' },
    { path: 'POST /api/4/coupons', description: 'Create coupon' },
    { path: 'PUT /api/4/coupons/{id}', description: 'Update coupon' },
  ]},
  { category: 'Customers', endpoints: [
    { path: 'GET /api/4/customers', description: 'List customers' },
    { path: 'GET /api/4/customers/{id}', description: 'Fetch customer' },
    { path: 'POST /api/4/customers', description: 'Create customer' },
    { path: 'PUT /api/4/customers/{id}', description: 'Update customer' },
  ]},
  { category: 'Default Properties', endpoints: [
    { path: 'GET /api/4/default_properties', description: 'List default properties' },
    { path: 'GET /api/4/default_properties/{id}', description: 'Fetch default property' },
    { path: 'POST /api/4/default_properties', description: 'Create default property' },
    { path: 'PUT /api/4/default_properties/{id}', description: 'Update default property' },
    { path: 'DELETE /api/4/default_properties/{id}', description: 'Delete default property' },
  ]},
  { category: 'Documents', endpoints: [
    { path: 'GET /api/4/documents', description: 'List documents' },
    { path: 'GET /api/4/documents/{id}', description: 'Fetch document' },
    { path: 'POST /api/4/documents', description: 'Create document' },
    { path: 'PUT /api/4/documents/{id}', description: 'Update document' },
  ]},
  { category: 'Emails', endpoints: [
    { path: 'GET /api/4/emails', description: 'List emails' },
    { path: 'POST /api/4/emails', description: 'Send email' },
  ]},
  { category: 'Email Templates', endpoints: [
    { path: 'GET /api/4/email_templates', description: 'List email templates' },
    { path: 'GET /api/4/email_templates/{id}', description: 'Fetch email template' },
    { path: 'POST /api/4/email_templates', description: 'Create email template' },
    { path: 'PUT /api/4/email_templates/{id}', description: 'Update email template' },
    { path: 'DELETE /api/4/email_templates/{id}', description: 'Delete email template' },
  ]},
  { category: 'Employees', endpoints: [
    { path: 'GET /api/4/employees', description: 'List employees' },
    { path: 'GET /api/4/employees/{id}', description: 'Fetch employee' },
    { path: 'PUT /api/4/employees/{id}', description: 'Update employee' },
  ]},
  { category: 'Inventory', endpoints: [
    { path: 'GET /api/4/inventory_breakdowns', description: 'List inventory breakdowns' },
    { path: 'GET /api/4/inventory_levels', description: 'Fetch inventory levels' },
  ]},
  { category: 'Items', endpoints: [
    { path: 'GET /api/4/items', description: 'List items' },
    { path: 'GET /api/4/items/{id}', description: 'Fetch item' },
  ]},
  { category: 'Lines', endpoints: [
    { path: 'GET /api/4/lines', description: 'List lines' },
    { path: 'GET /api/4/lines/{id}', description: 'Fetch line' },
    { path: 'POST /api/4/lines', description: 'Create line' },
    { path: 'PUT /api/4/lines/{id}', description: 'Update line' },
  ]},
  { category: 'Locations', endpoints: [
    { path: 'GET /api/4/locations', description: 'List locations' },
    { path: 'GET /api/4/locations/{id}', description: 'Fetch location' },
    { path: 'POST /api/4/locations', description: 'Create location' },
    { path: 'PUT /api/4/locations/{id}', description: 'Update location' },
  ]},
  { category: 'Notes', endpoints: [
    { path: 'GET /api/4/notes', description: 'List notes' },
    { path: 'GET /api/4/notes/{id}', description: 'Fetch note' },
    { path: 'POST /api/4/notes', description: 'Create note' },
    { path: 'DELETE /api/4/notes/{id}', description: 'Delete note' },
  ]},
  { category: 'Orders', endpoints: [
    { path: 'GET /api/4/orders', description: 'List orders' },
    { path: 'GET /api/4/orders/{id}', description: 'Fetch order' },
    { path: 'GET /api/4/orders/new', description: 'New order template' },
    { path: 'POST /api/4/orders', description: 'Create order' },
    { path: 'PUT /api/4/orders/{id}', description: 'Update order' },
  ]},
  { category: 'Payments', endpoints: [
    { path: 'GET /api/4/payments', description: 'List payments' },
    { path: 'GET /api/4/payments/{id}', description: 'Fetch payment' },
  ]},
  { category: 'Payment Methods', endpoints: [
    { path: 'GET /api/4/payment_methods', description: 'List payment methods' },
    { path: 'POST /api/4/payment_methods', description: 'Create payment method' },
    { path: 'DELETE /api/4/payment_methods/{id}', description: 'Delete payment method' },
  ]},
  { category: 'Photos', endpoints: [
    { path: 'GET /api/4/photos', description: 'List photos' },
    { path: 'GET /api/4/photos/{id}', description: 'Fetch photo' },
    { path: 'POST /api/4/photos', description: 'Create photo' },
    { path: 'PUT /api/4/photos/{id}', description: 'Update photo' },
    { path: 'DELETE /api/4/photos/{id}', description: 'Delete photo' },
  ]},
  { category: 'Plannings', endpoints: [
    { path: 'GET /api/4/plannings', description: 'List plannings' },
    { path: 'GET /api/4/plannings/{id}', description: 'Fetch planning' },
  ]},
  { category: 'Pricing', endpoints: [
    { path: 'GET /api/4/price_rulesets', description: 'List price rulesets' },
    { path: 'GET /api/4/price_rulesets/{id}', description: 'Fetch price ruleset' },
    { path: 'POST /api/4/price_rulesets', description: 'Create price ruleset' },
    { path: 'PUT /api/4/price_rulesets/{id}', description: 'Update price ruleset' },
    { path: 'GET /api/4/price_structures', description: 'List price structures' },
    { path: 'GET /api/4/price_structures/{id}', description: 'Fetch price structure' },
    { path: 'POST /api/4/price_structures', description: 'Create price structure' },
    { path: 'PUT /api/4/price_structures/{id}', description: 'Update price structure' },
    { path: 'DELETE /api/4/price_structures/{id}', description: 'Delete price structure' },
    { path: 'GET /api/4/price_tiles', description: 'List price tiles' },
    { path: 'GET /api/4/price_tiles/{id}', description: 'Fetch price tile' },
    { path: 'POST /api/4/price_tiles', description: 'Create price tile' },
    { path: 'PUT /api/4/price_tiles/{id}', description: 'Update price tile' },
    { path: 'DELETE /api/4/price_tiles/{id}', description: 'Delete price tile' },
  ]},
  { category: 'Products', endpoints: [
    { path: 'GET /api/4/products', description: 'List products' },
    { path: 'GET /api/4/products/{id}', description: 'Fetch product' },
    { path: 'POST /api/4/products', description: 'Create product' },
    { path: 'PUT /api/4/products/{id}', description: 'Update product' },
  ]},
  { category: 'Product Groups', endpoints: [
    { path: 'GET /api/4/product_groups', description: 'List product groups' },
    { path: 'GET /api/4/product_groups/{id}', description: 'Fetch product group' },
    { path: 'POST /api/4/product_groups', description: 'Create product group' },
    { path: 'PUT /api/4/product_groups/{id}', description: 'Update product group' },
  ]},
  { category: 'Properties', endpoints: [
    { path: 'GET /api/4/properties', description: 'List properties' },
    { path: 'GET /api/4/properties/{id}', description: 'Fetch property' },
    { path: 'POST /api/4/properties', description: 'Create property' },
    { path: 'PUT /api/4/properties/{id}', description: 'Update property' },
    { path: 'DELETE /api/4/properties/{id}', description: 'Delete property' },
  ]},
  { category: 'Provinces', endpoints: [
    { path: 'GET /api/4/provinces', description: 'List provinces' },
  ]},
  { category: 'Settings', endpoints: [
    { path: 'GET /api/4/settings', description: 'Fetch settings' },
  ]},
  { category: 'Stock Items', endpoints: [
    { path: 'GET /api/4/stock_items', description: 'List stock items' },
    { path: 'GET /api/4/stock_items/{id}', description: 'Fetch stock item' },
    { path: 'POST /api/4/stock_items', description: 'Create stock item' },
    { path: 'PUT /api/4/stock_items/{id}', description: 'Update stock item' },
  ]},
  { category: 'Tags', endpoints: [
    { path: 'GET /api/4/tags', description: 'List tags' },
  ]},
  { category: 'Taxes', endpoints: [
    { path: 'GET /api/4/tax_categories', description: 'List tax categories' },
    { path: 'GET /api/4/tax_categories/{id}', description: 'Fetch tax category' },
    { path: 'POST /api/4/tax_categories', description: 'Create tax category' },
    { path: 'PUT /api/4/tax_categories/{id}', description: 'Update tax category' },
    { path: 'DELETE /api/4/tax_categories/{id}', description: 'Delete tax category' },
    { path: 'GET /api/4/tax_rates', description: 'List tax rates' },
    { path: 'GET /api/4/tax_rates/{id}', description: 'Fetch tax rate' },
    { path: 'POST /api/4/tax_rates', description: 'Create tax rate' },
    { path: 'PUT /api/4/tax_rates/{id}', description: 'Update tax rate' },
    { path: 'DELETE /api/4/tax_rates/{id}', description: 'Delete tax rate' },
    { path: 'GET /api/4/tax_values', description: 'List tax values' },
    { path: 'GET /api/4/tax_values/{id}', description: 'Fetch tax value' },
  ]},
  { category: 'Transfers', endpoints: [
    { path: 'GET /api/4/transfers', description: 'List transfers' },
  ]},
  { category: 'Users', endpoints: [
    { path: 'GET /api/4/users', description: 'List users' },
    { path: 'GET /api/4/users/{id}', description: 'Fetch user' },
    { path: 'POST /api/4/users', description: 'Create user' },
    { path: 'PUT /api/4/users/{id}', description: 'Update user' },
  ]},
  { category: 'Webhooks', endpoints: [
    { path: 'GET /api/4/webhook_endpoints', description: 'List webhook endpoints' },
    { path: 'POST /api/4/webhook_endpoints', description: 'Create webhook endpoint' },
    { path: 'PUT /api/4/webhook_endpoints/{id}', description: 'Update webhook endpoint' },
    { path: 'DELETE /api/4/webhook_endpoints/{id}', description: 'Delete webhook endpoint' },
    { path: 'GET /api/4/webhooks/{id}', description: 'Fetch webhook' },
  ]},
];
